import React, { useState, useEffect, useMemo } from "react";
import { Container, Row, Col, Card, Input } from "reactstrap";
import { connect } from 'react-redux';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";

function ProductListingVariations(props) {
  const oldData = (props.listingData && props.listingData.catalogData) || {};
  const [variants, setVariants] = useState([]);

  const oldVariants = useMemo(() => {
    if (oldData.variants && oldData.variants.length > 0) {
      return oldData.variants;
    }
    if (oldData.sku) {
      const skuArray = String(oldData.sku).split(",").map(s => s.trim());
      return skuArray.map(singleSku => ({
        sku: singleSku,
        size: oldData.size || "",
        color: oldData.color || ""
      }));
    }
    return [];
  }, [oldData]);

  useEffect(() => {
    if (props.listingData) {
      if (props.listingData.variants && props.listingData.variants.length > 0) {
        setVariants(props.listingData.variants);
      } 
      else if (props.listingData.formData && props.listingData.formData.sku) {
        const formData = props.listingData.formData;
        const skuArray = String(formData.sku).split(",").map(s => s.trim());
        
        const formattedVariants = skuArray.map(singleSku => ({
          sku: singleSku,
          size: formData.size || "",
          color: formData.color || ""
        }));
        
        setVariants(formattedVariants);
      } 
      else {
        setVariants([{ sku: "", size: "", color: "" }]);
      }
    }
  }, [props.listingData]);

  const COLOR_OPTIONS = [
    "Black", "White", "Grey", "Silver", "Gold",
    "Red", "Blue", "Navy Blue", "Sky Blue",
    "Green", "Dark Green", "Olive Green",
    "Yellow", "Mustard Yellow",
    "Pink", "Hot Pink",
    "Purple", "Lavender","Orange",
    "Brown", "Dark Brown", "Light Brown",
    "Beige", "Cream", "Ivory",
    "Multicolor", "Transparent"
  ];

  const ALL_SIZES = [
    "4 × 6 in", "5 × 7 in", "6 × 8 in",
    "8 × 10 in", "10 × 12 in", "12 × 16 in",
    "16 × 20 in", "18 × 24 in", "20 × 30 in", "24 × 36 in",
    "8 × 8 in", "10 × 10 in", "12 × 12 in",
    "16 × 16 in", "20 × 20 in",
    "24 in", "27 in", "32 in", "40 in", "43 in",
    "50 in", "55 in", "65 in", "75 in", "85 in","10 × 10 × 4 in",
    "12 × 10 × 4 in","15 × 12 × 6 in","20 × 15 × 8 in","24 × 18 × 10 in",
    "12 × 18 in", "16 × 24 in", "20 × 24 in",
    "30 × 40 in", "36 × 48 in",
    "10 × 15 cm", "13 × 18 cm", "15 × 20 cm",
    "20 × 25 cm", "30 × 40 cm",
    "1 m", "2 m", "3 m", "5 m",
  ];

  const handleChange = (index, field, value) => {
    const updatedVariants = [...variants];
    updatedVariants[index][field] = value;
    setVariants(updatedVariants);
  };

  const addVariant = () => {
    setVariants([...variants, { sku: "", size: "", color: "" }]);
  };

  const removeVariant = (index) => {
    setVariants(variants.filter((_, i) => i !== index));
  };

  const handleNext = () => {
    props.setListingData(prev => ({
      ...prev,
      variants: variants
    }));

    props.nextStep();
  };

  return (
    <Container>
      <Row>
        <Col md={12} className="mt-2 mb-2">
          <h4>Step 6 : Product Variations</h4>
        </Col>

        <Col md={12}>
          <Card className="p-4">
            
            {/* Global Column Headers */}
            <Row className="mb-4 text-center">
              <Col md={2} className="text-left"></Col>
              <Col md={4} className="text-left">
                <span className="text-muted"><b>Old Value</b></span>
              </Col>
              <Col md={6} className="text-left">
                <span className="text-muted"><b>New Value</b></span>
              </Col>
            </Row>

            {variants.map((variant, index) => {
              const oldVariant = oldVariants[index] || {};

              return (
                <div key={`variant-${index}`} className="mb-4 pb-3" style={{ borderBottom: "1px solid #eee" }}>
                  
                  <Row className="mb-3">
                    <Col md={12} className="d-flex justify-content-between align-items-center">
                      <h6 className="mb-0 text-primary"><b>Variant {index + 1}</b></h6>
                      
                      <div 
                        onClick={() => removeVariant(index)}
                        title="Delete"
                        style={{ cursor: "pointer" }}
                      >
                        <FontAwesomeIcon 
                          icon={faTrash} 
                          className="text-danger"
                          style={{ fontSize: "18px" }}
                        />
                      </div>
                    </Col>
                  </Row>

                  {/* SKU Row */}
                  <Row className="mb-2 align-items-center">
                    <Col md={2} className="amazon-listing-labels">SKU :</Col>
                    <Col md={4}>
                      <p className="mb-0">{oldVariant.sku || "N/A"}</p>
                    </Col>
                    <Col md={6}>
                      <Input
                        type="text"
                        value={variant.sku}
                        onChange={(e) => handleChange(index, "sku", e.target.value)}
                        placeholder="Enter SKU"
                      />
                    </Col>
                  </Row>

                  {/* Size Row */}
                  <Row className="mb-2 align-items-center">
                    <Col md={2} className="amazon-listing-labels">Size :</Col>
                    <Col md={4}>
                      <p className="mb-0">{oldVariant.size || "N/A"}</p>
                    </Col>
                    <Col md={6}>
                      <Input 
                        type="select" 
                        value={variant.size} 
                        onChange={(e) => handleChange(index, "size", e.target.value)}
                      >
                        <option value="">{variant.size || "Select Size"}</option>
                        {ALL_SIZES.map(s => <option key={s} value={s}>{s}</option>)}
                      </Input>
                    </Col>
                  </Row>

                  {/* Color Row */}
                  <Row className="mb-2 align-items-center">
                    <Col md={2} className="amazon-listing-labels">Color :</Col>
                    <Col md={4}>
                      <p className="mb-0">{oldVariant.color || "N/A"}</p>
                    </Col>
                    <Col md={6}>
                      <Input 
                        type="select" 
                        value={variant.color}
                        onChange={(e) => handleChange(index, "color", e.target.value)}
                      >
                        <option value="">{variant.color || "Select Color"}</option>
                        {COLOR_OPTIONS.map(c => <option key={c} value={c}>{c}</option>)}
                      </Input>
                    </Col>
                  </Row>

                </div>
              );
            })}

            <Row className="mt-3">
              <Col md={12}>
                <button className="btn btn-secondary" onClick={addVariant}>+ Add Variant</button>
              </Col>
            </Row>

          </Card>
        </Col>

        <Col md={12} className="mt-3 d-flex justify-content-between">
          <button className="btn btn-light" onClick={props.prevStep}>← Back</button>
          <button className="btn btn-primary" onClick={handleNext}>Next →</button>
        </Col>
      </Row>
    </Container>
  );
}

const mapStateToProps = state => {
  return {
    token: state.loggedUser.token,
  }
}

export default connect(mapStateToProps)(ProductListingVariations);